import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { subcontractorService } from '@services/organization/subcontractors';
import { Subcontractor } from '@models/organization.model';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

// Sprint 25, story-134. The key previously omitted organizationId (['organizations',
// 'subcontractors']), breaking the repo's own org-scoped-hook convention — switching
// organizations could show the previous org's subs until a hard refresh. `organizationId` is
// read from the same Redux selector every sibling org-scoped hook already reads.
export const useSubcontractors = (): UseQueryResult<Subcontractor[], Error> => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: ['organizations', organizationId, 'subcontractors'],
    queryFn: () => subcontractorService.getSubcontractors(),
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
  });
};